import {css} from 'emotion'
import { Easings } from './..'

export const SlideshowStyle = (prev, next) => css({
  position: 'relative',
  '.slideshow-article': {
    '&-container': {
      flexWrap: 'nowrap',
      '.flickity-viewport': {
        width: '100%',
      },
    },
    '&-nav': {
      position: 'absolute',
      top: 0,
      right: 0,
      transform: 'translateY(-100%)',
      zIndex: 2,
    
      'button': {
        background: 'none',
        border: 0,
        padding: '0.5rem 1rem',
        cursor: 'pointer',
        '& > svg': {
          fill: 'white',
        },
        '&.next': {
          transform: 'rotate(-90deg)',
          opacity: next ? 1 :0.5,
          cursor: next ? 'pointer': 'default',
        },
        '&.prev': {
          transform: 'rotate(90deg)',
          opacity: prev ? 1 : 0.5,
          cursor: prev ? 'pointer': 'default',
        },
      }
    },
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/slideshow.js